import { tituloModalMappingKeys } from './mappings';

export default rawData =>
    Object.fromEntries(
        Object.keys(tituloModalMappingKeys).map(key => [
            [tituloModalMappingKeys[key]],
            rawData[key],
        ])
    );
